// @flow

import React from "react";

import { isEmpty } from "ramda";

import {
  type ErrosSelecao,
  type MedidaSelecionada,
  ID_TIPO_AJUSTE_PRECO_PADRAO,
} from "../../../model";

import {
  type State,
  i18n,
  getAjustesPrecoSemProventosSelecionados,
  getExibirConfiguracoesAvancadas,
  analiseValorDaMedida,
} from "../../../state";

import SelecaoAjusteDePrecoSemProventos from "../configuracoes/ajusteDePreco/SelecaoAjusteDePrecoSemProventos";

export const criaFuncaoValidacaoSeriesComAjusteSemProventos = (
  state: State
) => (): ?ErrosSelecao => {
  const erros: ErrosSelecao = {};
  const { translate } = i18n(state);

  if (isEmpty(getAjustesPrecoSemProventosSelecionados(state)))
    erros.ajustesPrecoNaoSelecionados = translate("erro.selecioneAjuste");

  return erros;
};

export const processarSeriesComAjusteSemProventos = (
  state: State,
  medidas: Array<MedidaSelecionada>
): Array<MedidaSelecionada> => {
  const ajustesPreco = getAjustesPrecoSemProventosSelecionados(state) || [];
  const exibirConfiguracoesAvancadas = getExibirConfiguracoesAvancadas(state);

  return medidas.flatMap(medida =>
    ajustesPreco.map(ajuste => {
      return {
        ...medida,
        tipoAjuste: exibirConfiguracoesAvancadas
          ? ajuste
          : ID_TIPO_AJUSTE_PRECO_PADRAO,
        ...analiseValorDaMedida(medida, state),
      };
    })
  );
};

const SeriesComAjusteSemProventos = () => {
  return (
    <>
      <SelecaoAjusteDePrecoSemProventos />
    </>
  );
};

export default SeriesComAjusteSemProventos;
